import { useTogglz } from '../../app-store/togglz/useTogglz';

export const CAMPAIGN_PRODUCTS = 'CAMPAIGN_PRODUCTS';
export const LOCALISATION = 'LOCALISATION';
export const BUSINESS_INTELLIGENCE = 'BUSINESS_INTELLIGENCE';
export const MULTI_LANGUAGE_SHOP = 'MULTI_LANGUAGE_SHOP';
export const COLLECTION_NAVIGATION_V2 = 'COLLECTION_NAVIGATION_V2';
export const USER_MANAGEMENT = 'USER_MANAGEMENT';
export const EXPIRY_REPORT = 'EXPIRY_REPORT';

export type FeatureFlag =
    | typeof CAMPAIGN_PRODUCTS
    | typeof BUSINESS_INTELLIGENCE
    | typeof LOCALISATION
    | typeof MULTI_LANGUAGE_SHOP
    | typeof COLLECTION_NAVIGATION_V2
    | typeof USER_MANAGEMENT
    | typeof EXPIRY_REPORT;

export type Toggl = {
    readonly name: FeatureFlag;
    readonly enabled: boolean;
};

export function useFeature(feature: FeatureFlag): boolean {
    const { togglz } = useTogglz();
    return (togglz && togglz[feature]?.enabled) ?? false;
}
